import request from "./request";

const getProducts = () => request("/bi/prodcuts", null, "GET");

const getAdvertiserInfo = (data) => request("/bi/getAdvertiserInfo", data, "POST_JSON");

//修改
const modifyAdvertiserInfo = (data) => request("/bi/modifyAdvertiserInfo", data, "POST");

//删除
const deleteAdvertiserInfo = (data) => request("/bi/deleteAdvertiserInfo", data, "POST");

// 获取用户渠道地区权限配置
export const getUserRefPerms = (param) => request("/common/userRefPerms", param, "GET");
// 获取角色渠道地区权限配置
export const getRoleRefPerms = (param) => request("/common/roleRefPerms", param, "GET");

// 编辑保存用户渠道地区权限配置
export const saveUserRefPerms = (param) => request("/common/saveUserRefPerms", param, "POST_JSON");
// 编辑保存角色渠道地区权限配置
export const saveRoleRefPerms = (param) => request("/common/saveRoleRefPerms", param, "POST_JSON");
// 产品权限详情列表
export const getProductPermDetailList = (param) =>
  request("/uapp/permDetailList", param, "POST_JSON");

//同步广告账号
const uploadAdvertiseInfo = () => request("/bi/uploadAdvertiseInfo", null, "GET");

// 获取用户列表树状
export const getRoleUserTree = (param) => request("/uapp/userInfosTree", param, "GET");
// 添加角色
export const addRole = (data) => request("/role/add", data, "POST_JSON");
// 编辑角色
export const editRole = (data) => request("/role/edit", data, "POST_JSON");
// 删除角色
export const delRole = (data) => request("/role/del", data, "GET");
// 获取角色列表
export const getRoleList = (data) => request("/role/list", data, "POST_JSON");
// 用户管理授权角色
export const addUserRoles = (data) => request("/role/addUserRoles", data, "GET");
// 获取用户列表
export const getUserList = (data) => request("role/userList", data, "POST_JSON");


export default {
  getProducts,
  getRoleUserTree,
  getAdvertiserInfo,
  modifyAdvertiserInfo,
  deleteAdvertiserInfo,
  uploadAdvertiseInfo,
};
